import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { ButtonGroup, Button } from 'blocket-ui'

const createItems = (items, required) => {
  const _items = [...items]
  if (!required) {
    _items.unshift({
      label: 'Alla',
      value: '',
    })
  }

  return _items
}

const ButtonGroupCollection = ({
  currentQuery,
  queryKey,
  required,
  defaultValue,
  onChange,
  items,
}) => {
  const _items = useMemo(() => createItems(items, required), [items, required])

  const selectedValue = currentQuery[queryKey] || defaultValue || ''

  return (
    <ButtonGroup>
      {_items.map(({ label, value }) => {
        const selected = selectedValue === value
        const handleChange = (e) => {
          onChange(e, queryKey, value)
        }

        return (
          <Button
            key={label}
            onClick={handleChange}
            size="tiny"
            type={selected ? 'secondary' : 'default'}
          >
            {label}
          </Button>
        )
      })}
    </ButtonGroup>
  )
}

export default ButtonGroupCollection

ButtonGroupCollection.propTypes = {
  currentQuery: PropTypes.object.isRequired,
  queryKey: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  defaultValue: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
}
